import { loadStripe } from '@stripe/stripe-js/pure';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { useEffect, useContext } from 'react';
import { CheckoutContext } from "../lib/CheckoutContext";
import { logAmplitudeEvent } from '../lib/amplitude';
import Banner from './banner';
import { Statsig } from 'statsig-react';

export default function CheckoutUI(props) {
    const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);
    const { uiLocation, checkoutOpen, quantity, paymentMode, subscribeClientSecret, setSubscribeClientSecret, paymentClientSecret, setPaymentClientSecret, weeklyClientSecret, setWeeklyClientSecret, setPaymentMode, setCheckoutOpen, switchCheckout, setSwitchCheckout, unauthCheckout, setUnauthCheckout } = useContext(CheckoutContext);
    const margin_all = props.margin_top || (uiLocation == 'credits-paywall');

    useEffect(() => {
        if (checkoutOpen && paymentMode) {
          logAmplitudeEvent('Checkout View', { trigger: uiLocation, pageRoute: window.location.pathname, paymentMode: paymentMode, quantity: quantity})
          Statsig.logEvent('checkout_viewed', null, {trigger: uiLocation, paymentMode: paymentMode, quantity: quantity})
        }        
        if ((paymentMode == "payment" && !paymentClientSecret) || (paymentMode == "subscription" && !subscribeClientSecret) || (paymentMode == "weekly-subscription" && !weeklyClientSecret)) {       

        fetch("/api/checkout_sessions", {          
          method: "POST",          
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ quantity: quantity, payment_mode: paymentMode}),          
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.error) {
              // setCheckoutOpen(false);
              // setUnauthCheckout(true);
              // window.location.href = '/login';
              return;
            }
            if (paymentMode == "subscription") {
              setSubscribeClientSecret(data["clientSecret"]);
            }
            else if (paymentMode == "weekly-subscription") {
              setWeeklyClientSecret(data["clientSecret"]);
            }            
            else {
              setPaymentClientSecret(data["clientSecret"]);
            }
        })
      }
      if (switchCheckout) {
        setCheckoutOpen(true);
        setSwitchCheckout(false);
      }
      }, [ paymentMode ]);

      function switchCheckoutSession() {        
        // let toSwitch = paymentMode == "payment" ? "subscription" : "payment";
        let toSwitch;
        if (paymentMode == "payment") {
          toSwitch = "weekly-subscription";
        } else if (paymentMode == "weekly-subscription") {
          toSwitch = "subscription";
        } else if (paymentMode == "subscription") {
          toSwitch = "payment";
        }        
        logAmplitudeEvent('Checkout Switch', { trigger: uiLocation, paymentMode: paymentMode, toSwitch: toSwitch})
        setPaymentMode(toSwitch);        
        setCheckoutOpen(false);
        setSwitchCheckout(true);
        // setCheckoutOpen(true);
      }
    return (
        <div id="checkout" className="w-full h-[auto]">    
          {(paymentMode == "payment") &&
          <Banner id={"checkout-banner"} payment_mode={paymentMode} handler={switchCheckoutSession} margin_top={margin_all}/>
          }    
            {checkoutOpen && (
                <>
                    {paymentMode === 'subscription' && subscribeClientSecret ? (
                        <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret: subscribeClientSecret }}>
                            <EmbeddedCheckout />
                        </EmbeddedCheckoutProvider>
                    ) : paymentMode === 'weekly-subscription' && weeklyClientSecret ? (
                        <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret: weeklyClientSecret }}>
                            <EmbeddedCheckout />
                        </EmbeddedCheckoutProvider>
                    ) : paymentMode === 'payment' && paymentClientSecret ? (
                        <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret: paymentClientSecret }}>
                            <EmbeddedCheckout />
                        </EmbeddedCheckoutProvider>
                    ) : (
                        <div className='m-10 text-center'>
                            <span className="loading loading-spinner loading-md text-slate-500"></span>
                        </div>
                    )}
                </>
            )}         
          {( paymentMode != "payment") &&
            <Banner id={"checkout-banner"} payment_mode={paymentMode} handler={switchCheckoutSession} margin_top={true}/>
          }                     
        </div>
    )
}